const parseFloatToNDecimals = (value, decimalPlaces = 2) =>
  Number(parseFloat(value).toFixed(decimalPlaces));

export default parseFloatToNDecimals;
